// src/utils/questionTypes.ts
//
// The console's display-order and label source for the five routing-rule
// question types (Story 1.5). The keys are the cross-story contract fixed in
// database/022's header (Stories 3.4/3.6 adopt them verbatim); the labels and
// order are UI concerns owned here so the rules screen renders one card per
// type in a fixed order.

import type { YakQuestionType } from '../types/yak'

// Fixed render order for the rules cards (AC 1).
export const QUESTION_TYPES: YakQuestionType[] = [
  'formulary_status',
  'rejected_rx',
  'out_of_pocket',
  'pharmacy_wholesaler',
  'other',
]

export const QUESTION_TYPE_LABELS: Record<YakQuestionType, string> = {
  formulary_status: 'Formulary status',
  rejected_rx: 'Rejected Rx / prior auth',
  out_of_pocket: 'Out-of-pocket / copay',
  pharmacy_wholesaler: 'Pharmacy & wholesaler availability',
  other: 'Other',
}
